import React from 'react'
import { Route, RouteProps as ReactRouteProps } from 'react-router-dom'

// Constants
import { RouteProps, routes } from '@sketch/constants'

// Utils
import { useQueryParams } from 'utils'

// Hooks
import { getIsForInAppPresentation } from 'modules/user/hooks'
import { useUserAuthorizations } from 'modules/sso/operations'

// Local Components
import { LinkAccountConfirmationPage } from '../LinkAccountConfirmationPage'
import { RedirectingToIdentityProvider } from '../RedirectingToIdentityProvider'
import { SignInToLinkAccountPage } from '../SignInToLinkAccountPage'
import { SsoErrorPage } from '../SsoErrorPage'
import SsoSignInView from '../SsoSignInView'
import SsoSuccessfulSignInView from '../SsoSuccessfulSignInView'
import { SsoTosPage } from '../SsoTosPage'

export const SignInRoute: React.FC<RouteProps<'SSO_SIGN_IN'>> = props => {
  const { team, shortname } = useQueryParams<'SSO_SIGN_IN'>()
  const isForInAppPresentation = getIsForInAppPresentation()

  if (isForInAppPresentation && (team || shortname)) {
    return <RedirectingToIdentityProvider />
  }

  return <SsoSignInView {...props} />
}

const LinkAccountRoute = () => {
  const { hasPersonalAuthorization } = useUserAuthorizations()

  if (hasPersonalAuthorization) {
    return <LinkAccountConfirmationPage />
  } else {
    return <SignInToLinkAccountPage />
  }
}

export const SsoRoutes: React.FC<ReactRouteProps> = () => {
  return (
    <>
      <Route
        exact
        path={routes.SSO_SIGN_IN.template()}
        component={SignInRoute}
      />

      <Route
        exact
        path={routes.SSO_ERROR.template()}
        component={SsoErrorPage}
      />

      <Route
        exact
        path={routes.SSO_SUCCESSFUL_SIGN_IN.template()}
        component={SsoSuccessfulSignInView}
      />

      <Route
        exact
        path={routes.SSO_LINK_ACCOUNT.template()}
        component={LinkAccountRoute}
      />

      <Route exact path={routes.SSO_TOS.template()} component={SsoTosPage} />
    </>
  )
}
